import { TimelineLite } from 'gsap/TimelineLite';
import { Power4 } from 'gsap/EasePack';
import { qs } from '@/scripts/utils';
import title from './title';

export default function footer(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const eyelet = qs('.project-footer__eyelet', ctx);
  const titleEl = qs('.project-footer__title', ctx);
  const line = qs('.line__span', ctx);
  const captionEl = qs('.project-footer__caption', ctx);
  const tl = new TimelineLite();

  tl.addLabel('start')
    .to(ctx, 1, { autoAlpha: 1 }, 'start')
    .add(title(eyelet), 'start+=0.5')
    .add(title(titleEl), 'start+=0.7')
    .from(line, 0.8, {
      scaleX: 0,
      transformOrigin: '0% 50%',
      ease: Power4.easeInOut
    }, 'start+=0.8')
    .add(title(captionEl), 'start+=1.2');

  return tl;
}

